'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addMinutes;


// WEBPACK FOOTER //
// ./~/sugar-date/date/addMinutes.js